import { useMemo, useState } from "react";
import {
  demoScreens,
  getDemoScreen,
  type DemoScreenId,
} from "../demoData";

const stepLabels: Record<DemoScreenId, string> = {
  bindings: "Bindings",
  "midi-routes": "MIDI routes",
  "target-picker": "Target picker",
  "configure-fader": "Configure fader",
  plugins: "Plugins",
  "on-screen-display": "On-screen display",
  appearance: "Appearance",
};

export function InteractiveDemo() {
  const [activeId, setActiveId] = useState<DemoScreenId>("bindings");
  const [hoveredStepId, setHoveredStepId] = useState<DemoScreenId | null>(null);
  const screen = useMemo(() => getDemoScreen(activeId), [activeId]);

  function stepState(stepId: DemoScreenId) {
    const classes = ["demo-step"];

    if (stepId === activeId) {
      classes.push("active");
    }

    if (stepId === hoveredStepId) {
      classes.push("is-linked");
    }

    return classes.join(" ");
  }

  return (
    <section className="demo-stage" aria-label="Interactive MIDIMaster screenshot tour">
      <div className="demo-stage-top">
        <div className="demo-current-screen" aria-hidden="true">
          {stepLabels[activeId]}
        </div>
        <p className="demo-tour-hint">Click tabs to explore screens.</p>
        <div className="demo-step-list" aria-label="Demo screens">
          {demoScreens.map((item, index) => (
            <button
              key={item.id}
              type="button"
              className={stepState(item.id)}
              onClick={() => {
                setHoveredStepId(null);
                setActiveId(item.id);
              }}
              onPointerEnter={() => setHoveredStepId(item.id)}
              onPointerLeave={() => setHoveredStepId(null)}
              onFocus={() => setHoveredStepId(item.id)}
              onBlur={() => setHoveredStepId(null)}
              aria-label={`Show ${stepLabels[item.id]} screen`}
            >
              <span>{index + 1}</span>
              {stepLabels[item.id]}
            </button>
          ))}
        </div>
      </div>

      <div className="demo-screen">
        <img className="is-active" src={screen.image} alt={screen.alt} decoding="async" />
      </div>
    </section>
  );
}
